import React, {useState, useEffect} from 'react'

import classes from './AudioButton.module.css'
import SoundPlayer from 'react-sdk/SoundPlayer';
import { FaVolumeHigh, FaVolumeOff } from 'react-icons/fa6';
import { observer } from 'mobx-react-lite';

const AudioButton = () => {

  return (
    <div className={classes.AudioButton} onClick={() => {
        SoundPlayer.playSound("click")
        SoundPlayer.muteMusic(!SoundPlayer._musicMute)
      }}>
      {SoundPlayer._musicMute ?
      <span className={classes.icon_off}> <FaVolumeOff /> </span> :
      <span className={classes.icon_on}> <FaVolumeHigh /> </span>}
    </div>
  );
};

export default observer(AudioButton);
